/* istanbul ignore file */

const successIcon = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Success</title>
    <rect x="4.5" y="4.5" width="15" height="15" rx="7.5" fill="#34A270" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.9414 9.64488L11.1097 15.4749C10.9182 15.6664 10.6572 15.772 10.3864 15.7676C10.1156 15.7632 9.85817 15.6491 9.67299 15.4515L7.05859 12.6612L8.51806 11.2937L10.4262 13.3302L15.5274 8.23047L16.9414 9.64488Z"
      fill="#E4F5EE"
    />
    <rect x="4.5" y="4.5" width="15" height="15" rx="7.5" stroke="#34A270" />
  </svg>
);

export default successIcon;
